var _a;
import { __assign } from "tslib";
import { PluginKey } from 'prosemirror-state';
import { pluginFactory } from '../../../utils/plugin-state-factory';
export var pluginKey = new PluginKey('mediaEditorPlugin');
export var reducer = function (state, action) {
    switch (action.type) {
        case 'open':
            return __assign(__assign({}, state), { editor: {
                    identifier: action.identifier,
                    pos: action.pos,
                } });
        case 'close':
            return __assign(__assign({}, state), { editor: undefined });
        case 'upload':
            return __assign(__assign({}, state), { editor: undefined });
        case 'setMediaClientConfig':
            return __assign(__assign({}, state), { mediaClientConfig: action.mediaClientConfig });
        default:
            return state;
    }
};
export var createPluginState = (_a = pluginFactory(pluginKey, reducer, {
    mapping: function (tr, state) {
        if (!state.editor) {
            return state;
        }
        // remap the position of the editing media inside the state
        return __assign(__assign({}, state), { editor: __assign(__assign({}, state.editor), { pos: tr.mapping.map(state.editor.pos) }) });
    },
}), _a.createPluginState), createCommand = _a.createCommand, getPluginState = _a.getPluginState;
//# sourceMappingURL=media-editor-plugin-factory.js.map